
import { useState } from 'react';

const Testimonials = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-award-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Licensed & Accredited</h3>
            <p className="text-gray-600">Fully licensed adult day care facility with state certifications and accreditations.</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Experienced Team</h3>
            <p className="text-gray-600">Our staff have years of experience in senior care and healthcare.</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-heart-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Family-Centered</h3>
            <p className="text-gray-600">We believe in involving families in care decisions and keeping them informed every step of the way.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
